import React from "react";
import "./Media.css";
import { useTranslation } from "react-i18next";

function Media() {
  const { t } = useTranslation();

  //TBA VI - https://indico.wacren.net/event/270/
  //CyberBastion - https://indico.wacren.net/event/271/

  const events = [
      {
      src: "/assets/images/cyberbation_2026.jpg",
      alt: "TrustBroker Africa community event",
      title: "CyberBastion Africa League",
      kicker: "CyberBastion Africa League",
      caption:
        "Connecting trusted teams across Africa through shared practice.",
      href: "https://indico.wacren.net/event/271/",
    },
    {
      src: "/assets/images/collab_2026.jpg",
      alt: "TrustBroker Africa collaboration session",
      title: "TrustBroker Africa (TBA) VI - Community Collaboration, Training, and Launch of CyberBastion Africa League",
      kicker: "Collaboration and Training",
      caption:
        "Connecting trusted teams across Africa through shared practice.",
      href: "https://indico.wacren.net/event/270/",
    },
  
    {
      src: "/assets/images/slider2.jpg",
      alt: "Event",
      title: t("cyber_threat"),
      href: "https://indico.wacren.net/event/245/",
    },
    {
      src: "/assets/images/SIM3-Auditor-Certification-Training-2024.jpg",
      alt: "Event",
      title: t("TBA SIM3"),
      href: "https://indico.wacren.net/event/202/",
    },
    {
      src: "/assets/images/NgREN_TBAIII.png",
      alt: "Event",
      title: t("TBA III"),
      href: "https://indico.wacren.net/event/179/",
    },
    {
      src: "/assets/images/BOCRA_TBAII.png",
      alt: "Event",
      title: t("community-building workshop"),
      href: "https://indico.wacren.net/event/146//",
    },
    {
      src: "/assets/images/tba-cert.png",
      alt: "Event",
      title: t("CSIRT training"),
      href: "https://indico.wacren.net/event/124/",
    },
  ];

  // const [showMore, setShowMore] = useState(false);

  // const handleReadMoreClick = () => {
  //   setShowMore(!showMore);
  // };

  return (
    //   </section>
    <div className="media-page">
      <section className="events-section">
        <h2 className="section-title">Events</h2>
        <div className="events">
          {events.map((event) => (
            <div className="event" key={`${event.src}-${event.title}`}>
              <img src={event.src} alt={event.alt} className="event-image" />
              <p className="event-caption">
                {event.href ? (
                  <a
                    href={event.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {event.title}
                  </a>
                ) : (
                  event.title
                )}
              </p>
              {/* {event.kicker && event.kicker !== event.title ? (
                <p className="event-kicker">{event.kicker}</p>
              ) : null}
              {event.caption ? (
                <p className="event-description">{event.caption}</p>
              ) : null} */}
            </div>
          ))}
        </div>
      </section>

      {/* New Section Below Events */}
      <p className="text-center mt-2 mb-6">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://photos.wacren.net/index.php?/category/98"
        >
          {t("view photos")}{" "}
        </a>
      </p>

      {/* <section className="media-section">
        <h2 className="section-title">Photos</h2>
        <div className="media-grid photos-grid">
          <div className="media-card">
            <img
              src="/assets/images/tba1.jpg"
              alt="TBA III Workshop Abuja"
              className="media-image"
            />
            <p>
              {" "}
              <a
                href="  https://photos.wacren.net/index.php?/category/98"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("TBA III Workshop Abuja")}
              </a>{" "}
            </p>
          </div>
        </div>
      </section> */}
    </div>
  );
}

export default Media;
